import { useRef } from "react";
import { PaperClipIcon, PhotoIcon, VideoCameraIcon, DocumentIcon } from "@heroicons/react/24/outline";

const MediaAttachmentButton = ({ showMediaOptions, onToggleOptions, onFileSelect, mediaOptionsRef }) => {
  const fileInputRef = useRef(null)
  const cameraInputRef = useRef(null)

  const handleFileInputClick = (accept) => {
    fileInputRef.current.accept = accept
    fileInputRef.current.click()
    onToggleOptions(false)
  }

  const handleCameraClick = () => {
    cameraInputRef.current.click()
    onToggleOptions(false)
  }

  return (
    <div className="relative" ref={mediaOptionsRef}>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
        onChange={onFileSelect}
        className="hidden"
      />
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={onFileSelect}
        className="hidden"
      />
      <button
        onClick={() => onToggleOptions(!showMediaOptions)}
        className="p-3 rounded-lg bg-[#128C7E]/10 hover:bg-[#128C7E]/20 dark:bg-[#25D366]/10 dark:hover:bg-[#25D366]/20 text-[#128C7E] dark:text-[#25D366] transition-colors border border-[#128C7E]/30 dark:border-[#25D366]/30"
        title="Attach media"
      >
        <PaperClipIcon className="w-5 h-5" />
      </button>

      {/* Media Options Popup */}
      {showMediaOptions && (
        <div className="absolute bottom-full left-0 mb-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl p-2 space-y-1 z-10 w-56">
          <button
            onClick={() => handleFileInputClick("image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx")}
            className="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-left transition-colors"
          >
            <svg className="w-5 h-5 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">All Files</span>
          </button>
          <div className="border-t border-gray-200 dark:border-gray-700 my-1"></div>
          <button
            onClick={handleCameraClick}
            className="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-left transition-colors"
          >
            <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span className="text-sm text-gray-700 dark:text-gray-300">Camera</span>
          </button>
          <button
            onClick={() => handleFileInputClick("image/*")}
            className="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-left transition-colors"
          >
            <PhotoIcon className="w-5 h-5 text-blue-600" />
            <span className="text-sm text-gray-700 dark:text-gray-300">Image</span>
          </button>
          <button
            onClick={() => handleFileInputClick("video/*")}
            className="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-left transition-colors"
          >
            <VideoCameraIcon className="w-5 h-5 text-purple-600" />
            <span className="text-sm text-gray-700 dark:text-gray-300">Video</span>
          </button>
          <button
            onClick={() => handleFileInputClick(".pdf,.doc,.docx,.xls,.xlsx")}
            className="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-left transition-colors"
          >
            <DocumentIcon className="w-5 h-5 text-orange-600" />
            <span className="text-sm text-gray-700 dark:text-gray-300">Document</span>
          </button>
        </div>
      )}
    </div>
  )
}

export default MediaAttachmentButton

